module.exports = __webpack_public_path__ + "static/media/TopAgents2024.93163fd6.gif";